import {CommentIcon, type Icon} from '@primer/octicons-react'
import {ZeroState} from '../toolbar/ZeroState'

export function CommentsErrorFallback({
  heading = 'Unable to load comments',
  icon = CommentIcon,
}: {
  heading?: string
  icon?: Icon
}) {
  return (
    <div className="d-flex flex-column position-relative width-full height-full flex-justify-center">
      <ZeroState description="Try reloading the pull request page." heading={heading} icon={icon} headingLevel="h2" />
    </div>
  )
}
